/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Label_Full_NameInputs */

const en_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

const es_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

const de_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Name`)
};

const zh_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ar_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم الكامل`)
};

const fr_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom et prénom`)
};

const vi_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ và tên`)
};

const sw_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina kamili`)
};

const th_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อเต็ม`)
};

const bs_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ime i prezime`)
};

const ja_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルネーム`)
};

const ko_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const pt_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

const it_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

const sv_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständigt namn`)
};

const nl_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige naam`)
};

const da_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulde navn`)
};

const nb_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullt navn`)
};

const fi_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koko nimi`)
};

const pl_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko`)
};

const ru_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя и фамилия`)
};

const tr_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad soyad`)
};

const hi_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण नाम`)
};

const id_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama lengkap`)
};

const ms_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama penuh`)
};

const cs_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celé jméno`)
};

const el_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ονοματεπώνυμο`)
};

const he_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם מלא`)
};

const af_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige naam`)
};

const hu_auth_label_full_name = /** @type {(inputs: Auth_Label_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes név`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Auth_Label_Full_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_label_full_name = /** @type {((inputs?: Auth_Label_Full_NameInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Label_Full_NameInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_label_full_name(inputs)
	if (locale === "de") return de_auth_label_full_name(inputs)
	if (locale === "zh") return zh_auth_label_full_name(inputs)
	if (locale === "ar") return ar_auth_label_full_name(inputs)
	if (locale === "fr") return fr_auth_label_full_name(inputs)
	if (locale === "vi") return vi_auth_label_full_name(inputs)
	if (locale === "sw") return sw_auth_label_full_name(inputs)
	if (locale === "th") return th_auth_label_full_name(inputs)
	if (locale === "bs") return bs_auth_label_full_name(inputs)
	if (locale === "ja") return ja_auth_label_full_name(inputs)
	if (locale === "ko") return ko_auth_label_full_name(inputs)
	if (locale === "pt") return pt_auth_label_full_name(inputs)
	if (locale === "it") return it_auth_label_full_name(inputs)
	if (locale === "sv") return sv_auth_label_full_name(inputs)
	if (locale === "nl") return nl_auth_label_full_name(inputs)
	if (locale === "da") return da_auth_label_full_name(inputs)
	if (locale === "nb") return nb_auth_label_full_name(inputs)
	if (locale === "fi") return fi_auth_label_full_name(inputs)
	if (locale === "pl") return pl_auth_label_full_name(inputs)
	if (locale === "ru") return ru_auth_label_full_name(inputs)
	if (locale === "tr") return tr_auth_label_full_name(inputs)
	if (locale === "hi") return hi_auth_label_full_name(inputs)
	if (locale === "id") return id_auth_label_full_name(inputs)
	if (locale === "ms") return ms_auth_label_full_name(inputs)
	if (locale === "cs") return cs_auth_label_full_name(inputs)
	if (locale === "el") return el_auth_label_full_name(inputs)
	if (locale === "he") return he_auth_label_full_name(inputs)
	if (locale === "af") return af_auth_label_full_name(inputs)
	if (locale === "hu") return hu_auth_label_full_name(inputs)
	return en_auth_label_full_name(inputs)
});